import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarAppIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M8.33 1.67H2.5c-.5 0-.83.33-.83.83v5.83c0 .5.33.84.83.84h5.83c.5 0 .84-.34.84-.84V2.5c0-.5-.34-.83-.84-.83Zm0 9.16H2.5c-.5 0-.83.34-.83.84v5.83c0 .5.33.83.83.83h5.83c.5 0 .84-.33.84-.83v-5.83c0-.5-.34-.84-.84-.84Zm9.17-9.16h-5.83c-.5 0-.84.33-.84.83v5.83c0 .5.34.84.84.84h5.83c.5 0 .83-.34.83-.84V2.5c0-.5-.33-.83-.83-.83Zm0 9.16h-5.83c-.5 0-.84.34-.84.84v5.83c0 .5.34.83.84.83h5.83c.5 0 .83-.33.83-.83v-5.83c0-.5-.33-.84-.83-.84Z"
      fill="#5C64ED"
    />
    <path
      d="M8.33 1.67H2.5c-.5 0-.83.33-.83.83v5.83c0 .5.33.84.83.84h5.83c.5 0 .84-.34.84-.84V2.5c0-.5-.34-.83-.84-.83Zm0 9.16H2.5c-.5 0-.83.34-.83.84v5.83c0 .5.33.83.83.83h5.83c.5 0 .84-.33.84-.83v-5.83c0-.5-.34-.84-.84-.84Zm9.17-9.16h-5.83c-.5 0-.84.33-.84.83v5.83c0 .5.34.84.84.84h5.83c.5 0 .83-.34.83-.84V2.5c0-.5-.33-.83-.83-.83Zm0 9.16h-5.83c-.5 0-.84.34-.84.84v5.83c0 .5.34.83.84.83h5.83c.5 0 .83-.33.83-.83v-5.83c0-.5-.33-.84-.83-.84Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1="1.67"
        x2="10"
        y2="18.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarAppIcon.defaultProps = {
  sx: null,
}
